import {
  DEAL_CATEGORY_LABELS_FR,
  DEAL_SOURCE_LABELS_FR,
  LOSS_REASON_LABELS_FR,
  STAGE_LABELS_FR,
} from "../../domain/deals/dealConfig";

export const dealsFr = {
  stages: { ...STAGE_LABELS_FR },
  categories: { ...DEAL_CATEGORY_LABELS_FR },
  loss_reasons: { ...LOSS_REASON_LABELS_FR },
  sources: { ...DEAL_SOURCE_LABELS_FR },
  board: {
    totals_label: "Totaux du pipeline",
    // owner ruling: with a package the value is the MRR; a manual amount is annual (ARR, MRR = amount / 12)
    mrr_pipeline: "MRR du pipeline",
    mrr_weighted: "MRR pondéré",
    arr_pipeline: "ARR du pipeline",
    mrr_won_this_month: "MRR gagné ce mois-ci",
    mrr_active: "MRR actif (clients)",
    arr_active: "%{arr} /an · %{count} abonnement(s)",
    mrr_arr: "%{mrr} /mois · %{arr} /an",
    days_in_stage:
      "%{smart_count} jour dans l'étape |||| %{smart_count} jours dans l'étape",
    demo_chip: "Démo %{date}",
    lost_title: "Pourquoi ce deal est-il perdu ?",
    choose_reason: "Choisir une raison",
    mark_lost: "Marquer comme perdu",
    won_title: "Bravo ! Confirmez la vente",
    final_amount: "Montant final ($ CA)",
    confirm_won: "Confirmer la vente",
    cancel: "Annuler",
    close_month: "Clôture prévue (mois)",
    only_mine: "Mes deals",
  },
  fields: {
    source: "Source",
    loss_reason: "Raison de la perte",
    loss_reason_detail: "Précisez la raison",
    demo_at: "Date de la démo",
    teams_join_url: "Lien Teams",
    responsable: "Closer",
    setter: "Setter",
    account_manager: "Responsable de compte",
    referrer: "Apporteur",
  },
  owner: {
    roles_locked: "Seul un administrateur peut changer les rôles.",
    role_admin_only: "Seul un administrateur peut changer les rôles.",
    invalid_responsable:
      "Ce Closer n'est pas un utilisateur actif. Choisissez un utilisateur actif.",
    invalid_role_holder:
      "Ce rôle doit être confié à un utilisateur actif. Choisissez un utilisateur actif.",
    no_longer_visible:
      "Cette opportunité ne vous est plus visible : un administrateur a changé ses rôles.",
  },
  // GAVION deal package (76_): the « Forfait proposé » (its value = the MRR per month)
  proposal: {
    title: "Forfait proposé",
    package: "Forfait proposé",
    manual: "Montant manuel (aucun forfait)",
    manual_hint: "Pour un montant manuel, retirez le forfait (×).",
    billing: "Facturation",
    billings: { monthly: "Mensuelle", annual: "Annuelle" },
    annual_discount: "Annuelle (−%{pct} %)",
    addons: "Options",
    qty: "Quantité",
    value: "Valeur (MRR)",
    per_month: "/mois",
    computed: "Calculée depuis le forfait proposé : %{amount} /mois.",
    snapshot_note:
      "Les prix sont figés à l'enregistrement : un changement du catalogue ne modifie pas cette opportunité.",
    invalid: "Choix d'options invalide pour ce forfait.",
    reprice: "Mettre à jour au prix actuel",
    reprice_hint: "Les prix du catalogue ont changé depuis l'enregistrement.",
    repriced: "Valeur mise à jour : %{amount} /mois.",
    errors: {
      invalid_package:
        "Ce forfait n'est plus offert. Choisissez un forfait actif.",
      invalid_addons:
        "Une option n'est pas offerte pour ce forfait, ou sa quantité est invalide.",
      invalid_billing: "Choisissez une facturation mensuelle ou annuelle.",
      forbidden:
        "Seuls le Closer, le Responsable de compte et les administrateurs changent le forfait proposé.",
      no_proposal: "Cette opportunité n'a pas de forfait proposé.",
      deal_closed: "Une opportunité gagnée ou perdue garde sa valeur.",
    },
  },
  // GAVION deal amount visibility (72_): a Setter / Apporteur only never sees the amount
  amount: {
    hidden: "Valeur masquée",
    hidden_note: "Certaines valeurs sont masquées",
  },
  // GAVION deal-inline: « Créer Affaire » — a contact created in the deal's company, association with the company
  create_inline: {
    new_contact: "Nouveau contact",
    company_first: "Choisissez d'abord l'entreprise pour créer un contact.",
    form_title: "Nouveau contact chez %{company}",
    fields: {
      first_name: "Prénom",
      last_name: "Nom",
      email: "Courriel",
      phone: "Téléphone",
      title: "Titre",
    },
    create: "Créer le contact",
    creating: "Création…",
    cancel: "Annuler",
    required: "Le prénom et le nom sont obligatoires.",
    invalid_email: "Courriel invalide.",
    created: "Contact créé et ajouté à l'affaire.",
    error:
      "Le contact n'a pas pu être créé. Vérifiez votre connexion et réessayez.",
    duplicate: {
      email: "Un contact a déjà ce courriel : %{name}.",
      phone: "Un contact a déjà ce téléphone : %{name}.",
      name: "%{name} existe déjà chez cette entreprise.",
      use: "Ajouter ce contact",
      create_anyway: "Créer quand même",
    },
    link: {
      associate: "Associer ce contact à %{company}",
      no_company: "Ce contact n'a pas d'entreprise.",
      other_company:
        "Ce contact est chez %{company} : cochez pour le déplacer.",
      done: "%{smart_count} contact associé à l'entreprise |||| %{smart_count} contacts associés à l'entreprise",
      error:
        "L'affaire est créée, mais l'association des contacts à l'entreprise a échoué.",
    },
  },
  errors: {
    move_failed: "Le déplacement a échoué. Le deal est revenu à son étape.",
    amount: "Entrez un montant en dollars entiers.",
    teams_url: "Collez un lien https://teams.microsoft.com/…",
  },
};
